module.exports = __webpack_public_path__ + "media/entities/1001-a041da71.png";